import type { Action } from 'svelte/action';
 const intersect:Action= (node, callback)=> {
    // the node has been mounted in the DOM
    const intersectionObserver = new IntersectionObserver((entries) => {
      // If intersectionRatio is 0, the target is out of view
      // and we do not need to do anything.
      if (entries[0].intersectionRatio <= 0) return;

    callback()
    });
    // start observing
    intersectionObserver.observe(node);
    return {
      destroy() {
        // the node has been removed from the DOM
        intersectionObserver.disconnect()
      },
    };
 }
  
 export default intersect